
import React from 'react';
import MuiAlert from '@material-ui/lab/Alert';

const Alert = React.forwardRef((props: any, ref: any) => <MuiAlert elevation={6} variant="filled" {...props} ref={ref} />);

export { Alert };
